export default __webpack_public_path__ + "static/media/frame.c4ff32fe.svg";